import { useEffect } from "react";
import { installVisualViewportBridge } from "@/lib/visualViewport";

/**
 * Mount once at the root. Publishes Safari-aware viewport metrics to
 * `:root` as CSS variables (see installVisualViewportBridge).
 */
export default function VisualViewportBridge() {
  useEffect(() => installVisualViewportBridge(), []);
  return null;
}
